import { createUseStyles } from 'react-jss'
import {
  TableOfContents
} from 'UI'
import { CourseNeutralPath } from 'navigation/Routes'
import style from './style'
import Text from './text.json'

const useStyles = createUseStyles(style)
const percentage = 100

export default ({
  CompletionPercentage,
  isQuizOpen,
  Questions,
  createAttempt,
  courseId,
  openQuiz,
  currentVideo,
  Chapters,
  IsFree,
  isConnected,
  selectVideoToWatch,
  learningMode,
  expandAll,
  padding = 0,
  Slug,
  handleLockedVideoClick,
  IsAccessible,
  setQuestionPosition,
  standAloneChapters,
  videoClickHandler,
  handleClick,
  showPopUpAction,
  setPlay,
  noBorder
}) => {
  const { root } = useStyles({ padding })
  const handleSelectedVideo = (video) => {
    selectVideoToWatch(video)
    openQuiz(false)
  }
  const processedChapters = (IsFree && isConnected)
    ? Chapters.map(Chapter =>
        ({
          ...Chapter,
          Videos: Chapter.Videos.map(Video => ({
            ...Video,
            IsLocked: false
          }))
        }))
    : Chapters

  const handleClickTable = () => {
    if (handleClick) {
      showPopUpAction(true)
      setPlay && setPlay(true)
    } else {
      setPlay && setPlay(false)
    }
    openQuiz(true)
    setQuestionPosition(0)
    createAttempt(courseId)
  }

  return (
    <div className={root} data-test='course-table-of-content'>
      <TableOfContents
        noBorder={noBorder}
        standAloneChapters={standAloneChapters}
        learningMode={learningMode || (IsFree && isConnected)}
        expandAll={expandAll}
        chapters={processedChapters}
        currentVideo={currentVideo}
        onVideoClick={(chapters, chapter, video) => videoClickHandler ? videoClickHandler(video) : video.IsLocked ? handleLockedVideoClick() : handleSelectedVideo(video)}
        chapterClick={_ => null}
        baseUrl={`${CourseNeutralPath}/${Slug}`}
        AllowVideoClick
        endOfCourseQuizProps={(!!Questions && IsAccessible && isConnected)
          ? {
              tag: Text.endOfCourseQuiz.tag,
              title: Text.endOfCourseQuiz.title,
              isActive: isQuizOpen,
              isDisabled: CompletionPercentage < percentage,
              onClick: handleClickTable
            }
          : null}
      />
    </div>
  )
}
